/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { C as Checkbox, d as defineCustomElement$1 } from './p-DyFBFrV7.js';

const IonCheckbox = Checkbox;
const defineCustomElement = defineCustomElement$1;

export { IonCheckbox, defineCustomElement };
